import { Search, Button, Icons, Dropdown } from '@silverfort/sf-components';
import { IntegrationType } from './types';

const MAX_SEARCH_LENGTH = 64;

export type Filters = {
    providerType: string[];
};

type Props = {
    searchText: string;
    onSearchChange: (val: string) => void;
    handleAddIntegration?: () => void;
    selectedFilters: Filters;
    setSelectedFilters: (val: any) => void;
};

const providerTypeFilter = {
    id: 'providerType',
    title: 'Type',
    multiple: true,
    options: [
        { title: 'Notifications', value: IntegrationType.NOTIFICATIONS },
        { title: 'EDR', value: IntegrationType.EDR },
        { title: 'Risk Ingestion', value: IntegrationType.RISK_INGESTION },
        { title: 'ITSM', value: IntegrationType.ITSM }
    ]
};

const AlertsManagementFilters = ({
    searchText,
    onSearchChange,
    handleAddIntegration,
    selectedFilters,
    setSelectedFilters
}: Props) => {
    return (
        <div className="h-8 flex items-center justify-between">
            <Dropdown
                {...providerTypeFilter}
                items={providerTypeFilter.options}
                key={providerTypeFilter.id}
                variant="filter"
                searchable={false}
                selectedItems={selectedFilters[providerTypeFilter.id]}
                removable={!!selectedFilters[providerTypeFilter.id].length}
                onRemove={() => {
                    setSelectedFilters({ ...selectedFilters, [providerTypeFilter.id]: [] });
                }}
                onChange={(val) => {
                    setSelectedFilters({ ...selectedFilters, [providerTypeFilter.id]: val });
                }}
            />
            <div className="flex gap-2">
                <Search
                    text={searchText}
                    border={true}
                    placeholder="Search integration name"
                    onChange={(val) => {
                        if (val.length <= MAX_SEARCH_LENGTH) {
                            onSearchChange(val.toLowerCase());
                        } else {
                            console.error('search term too long');
                        }
                    }}
                />
                {handleAddIntegration && (
                    <Button iconLeft={Icons.Add} onClick={handleAddIntegration} text="Add Integration" />
                )}
            </div>
        </div>
    );
};

export default AlertsManagementFilters;
